import { Text } from 'braid-design-system';

import { EmDash } from 'src/App/Components/RecentJobs/Constants';

export const EmptyTableCell = () => <Text>{EmDash}</Text>;
